import React, { useState, useEffect } from 'react';

import { Typography, Dropdown } from '@hpstellar/core';

import withPageComponents from '../../../page/components/with-page-components';
import ScrollContainer from './scroll-container';
import StickyCard from './sticky-card';
import GameFPSModal from './game-fps-modal';
import ETRApi from '../../../core/src/etr-wcs-api-client';
import { getULParams, pickFPS, graphicsPresets } from './util';

import './game-fps.less';

const FPS_SELECTION_ID = 'GAMEFPS_SELECT';

const GameFPS = ({ baseConfig, skuList }) => {
    const { ULList } = baseConfig || {};
    const displayFPSCalc = Object.keys(ULList || {}).length > 0;
    const [graphicsPreset, setGraphicsPreset] = useState(graphicsPresets[0]);
    const [selecting, setSelecting] = useState(false);
    const [selection, setSelection] = useState([]);
    const [gameList, setGameList] = useState([]);
    const [gameTitles, setGameTitles] = useState({});
    //create sku list as a string to avoid duplicate estimate calls
    const skuListString = (skuList || []).join(',');
    useEffect(() => {
        //fetch the game list
        ETRApi.cto.gameList().then((gameList = {}) => {
            setGameList(gameList);

            if (sessionStorage.getItem(FPS_SELECTION_ID)) {
                const storedSelection = JSON.parse(sessionStorage.getItem(FPS_SELECTION_ID));
                setSelection(storedSelection.slice(0, 5));
            } else {
                setSelection(gameList.slice(0, 3));
            }
        });
    }, []);

    useEffect(() => {
        if (gameList.length > 0 && (skuList || []).length > 0) {
            try {
                const params = getULParams(skuList, ULList);
                ETRApi.cto.estimate(params).then(resp => {
                    const { gameTitles } = resp || {};
                    if (gameTitles) {
                        setGameTitles(gameTitles);
                    }
                });
            } catch (e) {
                console.log(e);
            }
        }
    }, [skuListString]);

    const itemClick = id => {
        setSelecting(true);
    };

    const fill = selected => {
        const fillSelection = Array(5).fill({});

        return fillSelection.map((item, index) => {
            if (index < selection.length) {
                return selected[index];
            }
            return {};
        });
    };

    const onSelection = selected => {
        sessionStorage.setItem(FPS_SELECTION_ID, JSON.stringify(selected));
        setSelection(selected);
    };

    const onRemove = id => {
        const newSelection = selection.filter((item, i) => i !== id);
        setSelection(newSelection);
    };

    const onModalClose = () => {
        setSelecting(false);
    };

    if (!displayFPSCalc) {
        return null;
    }

    return (
        <div className="gameFPSContainer">
            <div className="gameLeft">
                <Typography variant="bodyL">Real FPS Performance in your build</Typography>
                <Typography className="subtitle" variant="boldS">
                    Graphics Preset
                </Typography>
                <Dropdown
                    defaultValue={graphicsPreset}
                    onChange={setGraphicsPreset}
                    options={[
                        {
                            gtmSort: 'fullHdFps',
                            label: '1080p Medium',
                            value: graphicsPresets[0],
                        },
                        {
                            gtmSort: 'quadHdFps',
                            label: '1440p Ultra',
                            value: graphicsPresets[1],
                        },
                    ]}
                    style={{
                        maxWidth: 206,
                    }}
                    customLabel=""
                />
            </div>

            <ScrollContainer className="gameRight">
                {fill(selection).map((item, index) => (
                    <StickyCard
                        {...item}
                        fps={pickFPS(item, gameTitles, graphicsPreset)}
                        index={index}
                        key={index}
                        onClick={itemClick}
                        onRemove={onRemove}
                        selecting={selecting}
                    />
                ))}
            </ScrollContainer>
            <GameFPSModal
                gameList={gameList}
                gameTitles={gameTitles}
                selecting={selecting}
                selection={selection}
                onSelection={onSelection}
                onModalClose={onModalClose}
                graphicsPreset={graphicsPreset}
            />
        </div>
    );
};

export default withPageComponents(GameFPS, {
    components: ['baseConfig', 'skuList'],
    device: true,
});
